export default __webpack_public_path__ + "static/media/kimchi-fried-rice.583dc7c8.png";